import { memo } from "react";

import { alpha, Box, lighten, Tooltip, useTheme } from "@mui/material";

import { CELL_SIZE } from "../constants/timelineConstants";

function TimelineCell({
  active,
  deadline,
  holiday = false,
  color,
  tooltip,
  onClick,
  isCurrentWeek = false,
}) {
  const theme = useTheme();
  return (
    <Tooltip title={tooltip || ""}>
      <Box
        onClick={onClick}
        sx={{
          cursor: "pointer",

          width: CELL_SIZE,
          height: CELL_SIZE,

          position: "relative",
          overflow: "hidden",

          border: "1px solid",
          borderColor: "divider",

          bgcolor: deadline
            ? isCurrentWeek
              ? lighten(theme.palette.background.error, 0.1)
              : theme.palette.background.error
            : active
              ? isCurrentWeek
                ? lighten(color, 0.2)
                : color
              : holiday
                ? alpha(theme.palette.levels.lightPurple, 0.2)
                : isCurrentWeek
                  ? alpha(theme.palette.primary.main, 0.08)
                  : "background.paper",

          borderLeft: isCurrentWeek
            ? `2px solid ${theme.palette.primary.main}`
            : undefined,

          transition: "all 0.15s ease",

          "&:hover": {
            transform: "scale(1.15)",
          },

          "&::after": holiday
            ? {
                content: '""',

                position: "absolute",

                top: 0,
                left: 0,
                right: 0,
                bottom: 0,

                background:
                  "repeating-linear-gradient(45deg, rgba(0, 0, 0, 0.18), rgba(0,0,0,.28) 2px, transparent 2px, transparent 6px)",

                pointerEvents: "none",
              }
            : {},
        }}
      />
    </Tooltip>
  );
}

export default memo(TimelineCell);
